export default {
  nav: {
    main: 'Principale',
    ordersAndInvoices: 'Ordini e Fatture',
    drafts: 'Bozze',
    automation: 'Automazione',
    workspace: 'Area di lavoro',
    templates: 'Modelli',
    delivery: 'Consegna',
    settings: 'Impostazioni',
    shippingLabels: 'Etichette di spedizione',
    subscriptions: 'Abbonamenti',
    support: 'Supporto',
    developer: 'Sviluppatore',
    writeReview: 'Scrivi una recensione',
    supportTicket: 'Ticket di supporto',
    welcomeTour: 'Tour di benvenuto',
    administratorConsole: 'Console amministratore',
    logout: 'Esci',
  },
  dashboard: {
    pageTitle: 'Ordini e Fatture',
    pageDescription: 'Manage your orders and invoices',
    title: 'Ordini e Fatture',
    selectedOrders: '{count} ordini selezionati',
    completed: '% completato',
    processing: 'Elaborazione in corso, attendere...',
    bulkDownload: 'Download massivo',
    upgradeBulkDownload: 'Aggiorna il tuo piano per il Download massivo',
    showFilters: 'Mostra filtri',
    hideFilters: 'Nascondi filtri',
    creatingInvoices: 'Creazione fatture in corso, attendere...',
    bulkCreateInvoices: 'Creazione massiva fatture',
    cannotCreateAutopilot: 'Non puoi creare fatture manualmente quando la modalità di fatturazione è su pilota automatico.',
    exportInvoices: 'Esporta fatture o ordini',
    capturePayments: 'Registra pagamenti manualmente',
    filterOrders: 'Filtra ordini',
    error: 'Ops, qualcosa è andato storto...',
    close: 'Chiudi',
    chooseDate: 'Scegli una data',
    chooseIssueDate: 'Scegli una data di emissione per le fatture selezionate',
    cancel: 'Annulla',
    createInvoices: 'Crea fatture',
    storno: 'Storno',
    bulkOrderCapture: 'Registrazione massiva ordini',
  },
  search: {
    createdBetween: 'Creato tra',
    modifiedBetween: 'Modificato tra',
    orderNumber: 'Ordine #',
    invoiceNumber: 'Fattura #',
    refundNumber: 'Rimborso #',
    customer: 'Cliente',
    payment: 'Pagamento',
    any: 'Qualsiasi',
    authorized: 'Autorizzato',
    pending: 'In attesa',
    paid: 'Pagato',
    partiallyPaid: 'Parzialmente pagato',
    refunded: 'Rimborsato',
    voided: 'Annullato',
    partiallyRefunded: 'Parzialmente rimborsato',
    unpaid: 'Non pagato',
    fulfillment: 'Evasione',
    fulfilled: 'Spedito',
    partial: 'Parziale',
    unfulfilled: 'Non spedito',
    loading: 'Caricamento ordini...',
    search: 'Cerca',
  },
  orderList: {
    noCustomer: 'Nessun cliente',
    downloadOrder: 'Scarica ordine',
    deleteWarning: 'Importante! Questo eliminerà tutte le fatture e i rimborsi creati dopo la data:',
    includingInvoice: 'inclusa la fattura selezionata #',
    pressOk: 'Premi OK per continuare o Annulla per interrompere.',
    cannotCreateAutopilot: 'Non puoi creare fatture manualmente quando la modalità di fatturazione è su pilota automatico.',
    createInvoice: 'Crea fattura per questo ordine',
    create: 'Crea',
    addCreditNote: 'Aggiungi nota di credito',
    createStorno: 'Crea una fattura di storno',
    refund: 'Rimborso',
    downloadInvoice: 'Scarica questa fattura',
    download: 'Scarica',
    default: 'Predefinito',
    downloadStorno: 'Scarica questo storno/nota di credito',
    fulfillOrder: 'Evadi ordine',
    orderNum: 'Ordine #',
    locPrefix: 'Prefisso sede',
    invoiceNum: 'Fattura #',
    refundNum: 'Rimborso #',
    customerCol: 'Cliente',
    orderCreatedDate: 'Data creazione ordine',
    orderModifiedDate: 'Data modifica ordine',
    delivered: 'Consegnato',
    paymentStatus: 'Stato pagamento',
    fulfillmentStatus: 'Stato spedizione',
    totalOutstanding: 'Importo totale residuo',
    originalPrice: 'Prezzo originale',
    noOrders: 'Il tuo negozio non ha ordini per lo stato selezionato.',
    cannotCreateNoOrders: 'Non puoi creare fatture quando non ci sono ordini.',
    createOrdersFirst: 'Crea almeno un ordine e riprova.',
    createOrders: 'Crea ordini',
    loadingOrders: 'Caricamento...',
    paidManual: 'Pagato - Manuale',
    paid: 'Pagato',
    refunded: 'Rimborsato',
    pending: 'In attesa',
    partiallyPaid: 'Parzialmente pagato',
    partiallyRefunded: 'Parzialmente rimborsato',
    fulfilled: 'Spedito',
    unfulfilled: 'Non spedito',
    deliveryPending: 'In attesa',
    deliverNow: 'Consegna ora',
    deliveryPartial: 'Parziale',
    notDelivered: 'Non consegnato',
    deliverAgain: 'Consegna di nuovo',
    deliveryDetails: 'Dettagli consegna',
    deliveryFailed: 'Consegna fallita',
    sent: 'Inviato',
    failed: 'Fallito',
    toLabel: 'A',
    folderLabel: 'Cartella',
    open: 'Aperto',
    invoice: 'Fattura',
    creditNote: 'Nota di credito',
    stornoLabel: 'Storno',
    unknown: 'Sconosciuto',
    googleDrive: 'Google Drive',
    clientsTablet: 'Tablet clienti',
    shippyPro: 'ShippyPro',
    emailChannel: 'E-mail',
    ftpChannel: 'FTP',
    revertToDate: 'Ripristina a questa data',
    add: 'Aggiungi',
    close: 'Chiudi',
  },
  downloadDialog: {
    downloadType: 'Scarica {type}...',
    selectTemplate: 'Seleziona un modello dalla galleria per esportare ordini, fatture, fatture di storno o note di credito.',
    getMoreTemplates: 'Ottieni più modelli',
    createNewTemplate: 'Crea un nuovo modello',
    allCreatedBetween: 'Tutti i {type} creati tra',
    selectedType: '{type} selezionati',
    and: 'e',
    status: 'Stato',
    any: 'Qualsiasi',
    open: 'Aperto',
    closed: 'Chiuso',
    cancelled: 'Annullato',
    paymentStatus: 'Stato pagamento',
    fulfillmentStatus: 'Stato spedizione',
    fulfilled: 'Spedito',
    partial: 'Parziale',
    unfulfilled: 'Non spedito',
    authorized: 'Autorizzato',
    pending: 'In attesa',
    paid: 'Pagato',
    partiallyPaid: 'Parzialmente pagato',
    refunded: 'Rimborsato',
    voided: 'Annullato',
    partiallyRefunded: 'Parzialmente rimborsato',
    unpaid: 'Non pagato',
    format: 'Formato',
    forLocation: 'Per sede',
    advancedOptions: 'Opzioni avanzate',
    exportHSCodes: 'Esporta codici HS inventario (più lento)',
    noteChrome: 'Nota: Per un download ottimale si consiglia Chrome e di disabilitare qualsiasi adblocker.',
    downloadIndividually: 'Scarica singolarmente',
    downloadGrouped: 'Scarica raggruppato',
  },
  templates: {
    pageTitle: 'Modelli',
    pageDescription: 'Customize your invoice templates',
    title: 'Modelli',
    installTranslated: 'Installa un modello tradotto',
    installTranslatedDesc: 'Scegli una lingua diversa cliccando su questo pulsante.',
    createNew: 'Crea un nuovo modello se necessario',
    createNewDesc: 'Clicca su questo pulsante per creare un nuovo modello se necessario.',
    customize: 'Personalizza modelli',
    customizeDesc: 'Clicca sul modello predefinito per personalizzarlo. Puoi cambiare logo, colori e, per utenti più avanzati, il codice sottostante.',
    defaultTemplate: 'Fattura, Storno e Nota di credito (Predefinito)',
    logo: 'Logo',
    colorPalette: 'Tavolozza colori',
    getColorPalettes: 'Ottieni tavolozze di colori',
    paperSize: 'Formato carta',
    format: 'Formato',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: 'Orientamento',
    landscape: 'Orizzontale',
    portrait: 'Verticale',
    margin: 'Margine (cm)',
    unsavedChanges: 'Modifiche non salvate',
    discard: 'Annulla',
    save: 'Salva',
  },
  labels: {
    pageTitle: 'Etichette di spedizione',
    pageDescription: 'Create and manage shipping labels',
    title: 'Etichette di spedizione',
    glsRequiresPro: 'Le etichette di spedizione GLS per EEU richiedono il piano Professional.',
    upgradeDesc: 'Aggiorna a Professional per creare e gestire le etichette di spedizione.',
    upgradePlan: 'Aggiorna il tuo piano',
    eeuGls: 'EEU GLS',
    enabled: 'Abilitato',
    country: 'Paese',
    hungary: 'Ungheria',
    slovakia: 'Slovacchia',
    czech: 'Repubblica Ceca',
    romania: 'Romania',
    slovenia: 'Slovenia',
    croatia: 'Croazia',
    senderId: 'ID mittente',
    username: 'Nome utente',
    password: 'Password',
    name: 'Nome',
    city: 'Città',
    address: 'Indirizzo',
    zipCode: 'CAP',
    contactPerson: 'Persona di contatto',
    phone: 'Telefono',
    email: 'Email',
    glsServices: 'Servizi GLS',
    expressService: 'Servizio Express',
    exchangeService: 'Servizio di scambio',
    smsService: 'Servizio SMS',
    smsText: 'Testo SMS',
    preAdviceService: 'Servizio PreAdvice',
    unsavedChanges: 'Modifiche non salvate',
    discard: 'Annulla',
    save: 'Salva',
  },
  billing: {
    pageTitle: 'Fatturazione',
    pageDescription: 'Manage your subscription and billing',
    title: 'Fatturazione',
    subscriptionFor: 'Piano di abbonamento per il negozio',
    currentlySubscribed: 'Sei attualmente abbonato a',
    plan: 'piano',
    cancelSubscription: 'Annulla abbonamento',
    upgradePlan: 'Aggiorna il tuo piano',
    professional: 'Professional',
    proPriceMonthly: '$29.99 / mese',
    upgrade: 'Aggiorna',
    includesAllStarter: 'Include tutte le funzionalità Starter, più:',
    proFeature1: 'Suite di conformità globale: Prefissi basati sulla sede e numerazione sequenziale personalizzata',
    proFeature2: 'Localizzazione intelligente: Email tradotte automaticamente e allegati PDF localizzati',
    proFeature3: 'Ciclo di vita completo documenti B2B: Proforma, Preventivi B2B e Note di credito',
    proFeature4: 'Sincronizzazione contabile B2B: Precisione a 3 decimali e visualizzazione multi-valuta',
    proFeature5: 'Backup automatici: Copia automatica delle fatture su FTP sicuro o Google Drive',
    proFeature6: 'Shopify Flow: Automatizza la generazione, la consegna e lo storno delle fatture tramite trigger e azioni Flow',
    proFeature7: 'Logica AI avanzata: Usa l\'AI on-device per clausole condizionali complesse nel layout',
    proFeature8: 'Esportazioni UBL XML e ZUGFeRD / Factur-X (conformità E-invoicing europea)',
    proFeature9: 'Codici EPC QR per pagamenti POS mobili istantanei',
    proFeature10: 'Etichette di spedizione GLS per EEU',
    proFeature11: 'Conservazione fiscale conforme per 7 anni',
    currentlyUsing: 'Stai attualmente utilizzando il nostro',
    free: 'gratuito',
    subscriptionPlan: 'piano di abbonamento.',
    monthlyUsage: 'Utilizzo mensile',
    monthlyGenerated: '{count} / 50 fatture questo mese',
    monthlyLimitReached: 'Limite mensile raggiunto. Aggiorna a Starter per fatture illimitate.',
    freePlan: 'Piano gratuito',
    freeToInstall: 'Installazione gratuita',
    freeFeature1: 'Fino a 50 fatture/ordini al mese',
    freeFeature2: 'Accesso a tutti i 31+ modelli predefiniti',
    freeFeature3: 'AI Copilot base',
    freeFeature4: 'Download e stampa PDF standard',
    freeFeature5: 'Suite documenti standard (Fatture, Documenti di trasporto, Ricevute)',
    freeFeature6: 'Conservazione sicura fatture per 3 mesi',
    starterPlan: 'Piano Starter',
    starterPrice: '$9.99 / mese',
    starterPricePerInvoice: '+ 3¢ per fattura creata',
    subscribe: 'Abbonati',
    starterFeature1: 'Fatture e ordini illimitati',
    starterFeature2: 'Consegna automatica PDF via email',
    starterFeature3: 'Accesso completo all\'editor ibrido e AI Copilot',
    starterFeature4: 'Integrazione Shopify POS e codici a barre',
    starterFeature5: 'Shopify Flow: Trigger e azioni per l\'automazione delle fatture',
    starterFeature6: 'Esportazioni UBL XML / PEPPOL e ZUGFeRD / Factur-X (conformità E-invoicing)',
    starterFeature7: 'Conservazione sicura fatture per 1 anno',
    proTaxOverrides: 'Sovrascritture fiscali personalizzate: IVA / GST per prodotto e aliquote per SKU',
    unsavedChanges: 'Modifiche non salvate',
    discard: 'Annulla',
    save: 'Salva',
  },
  autopilot: {
    pageTitle: 'Automazione',
    pageDescription: 'Automate invoice creation and management',
    title: 'Automazione',
    autoCreate: 'Crea fatture automaticamente',
    disabled: 'Disabilitato (Manuale)',
    whenCreated: 'Quando gli ordini vengono creati',
    whenFulfilled: 'Quando gli ordini vengono evasi',
    whenPaid: 'Quando gli ordini vengono pagati',
    autoCreateDesc: 'Le fatture verranno create nella data in cui gli ordini vengono creati, evasi o pagati.',
    autoStorno: 'Storno automatico fatture',
    whenCancelled: 'Quando gli ordini vengono annullati o rimborsati',
    autoStornoDesc: 'Le fatture di storno verranno create nella data in cui gli ordini vengono annullati o i rimborsi vengono creati.',
    cannotAutoFree: 'La creazione automatica delle fatture non è disponibile con il piano gratuito.',
    upgradePlan: 'Aggiorna il tuo piano',
    unsavedChanges: 'Modifiche non salvate',
    discard: 'Annulla',
    save: 'Salva',
  },
  delivery: {
    pageTitle: 'Consegna',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Consegna',
    settings: 'Impostazioni',
    useOrderNumbers: 'Usa numeri d\'ordine per i file',
    sendIfCountry: 'Invia se il paese dell\'indirizzo di fatturazione è',
    countryCodesHint: 'Elenca tutti i codici paese separati da punto e virgola.',
    sendForTags: 'Invia per i clienti che hanno uno dei tag elencati',
    tagsHint: 'Elenca tutti i tag separati da punto e virgola.',
    emailDelivery: 'Consegna via email',
    sendAsPdf: 'Invia fatture come allegati PDF ai clienti',
    autoSend: 'Invia automaticamente quando una fattura viene creata',
    subject: 'Oggetto',
    body: 'Corpo',
    xmlAttachments: 'Allegati XML',
    attachUbl: 'Allega XML UBL/PEPPOL (E-Factura)',
    attachZugferd: 'Allega XML ZUGFeRD / Factur-X',
    sendTestEmail: 'Invia email di prova',
    sending: 'Invio in corso...',
    customSmtp: 'Server SMTP personalizzato',
    customSmtpDesc: 'Usa il tuo server di posta invece di quello predefinito',
    enableSmtp: 'Abilita SMTP personalizzato',
    smtpHost: 'Host SMTP',
    port: 'Porta',
    useSsl: 'Usa SSL/TLS',
    username: 'Nome utente',
    password: 'Password',
    fromEmail: 'Email mittente',
    fromName: 'Nome mittente',
    shopifyLiquid: 'Template Shopify Liquid',
    pasteInto: 'Incolla questo nel tuo',
    orderConfirmation: 'modello di conferma ordine',
    toAddLink: 'per aggiungere un link di download.',
    downloadInvoice: 'Scarica la tua fattura',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Invia richieste a ClientsTablet quando le fatture vengono create',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'Invia fatture PDF come documenti doganali a ShippyPro per i paesi extra-UE',
    ftpBackup: 'Backup FTP / SFTP',
    ftpDesc: 'Copia automatica delle fatture sul tuo server',
    enableFtp: 'Abilita backup FTP automatico',
    host: 'Host',
    useSftp: 'Usa SFTP (sicuro)',
    destinationFolder: 'Cartella di destinazione',
    xmlFiles: 'File XML',
    includeUbl: 'Includi XML UBL/PEPPOL (E-Factura)',
    includeZugferd: 'Includi XML ZUGFeRD / Factur-X',
    testConnection: 'Testa connessione',
    testing: 'Test in corso...',
    pro: 'PRO',
    upgradeFtp: 'Aggiorna a Professional per copiare automaticamente le fatture sul tuo server FTP/SFTP.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Sincronizza automaticamente le fatture sul tuo Drive',
    connected: 'Connesso',
    disconnect: 'Disconnetti',
    notWorking: 'Non funziona? Vai su',
    googlePermissions: 'Permessi Google',
    removeThenReconnect: 'rimuovi Invoice Browse, poi riconnetti.',
    connectGoogleDrive: 'Connetti Google Drive',
    upgradeGoogleDrive: 'Aggiorna a Professional per sincronizzare automaticamente le fatture su Google Drive.',
    unsavedChanges: 'Modifiche non salvate',
    discard: 'Annulla',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'Salva',
  },
  bookkeeping: {
    pageTitle: 'Impostazioni',
    pageDescription: 'Configure your invoice settings',
    title: 'Impostazioni',
    owner: 'Titolare',
    email: 'Email',
    phone: 'Telefono',
    keepDifferentNumbering: 'Mantieni numerazione fatture diversa per ogni sede dell\'ordine',
    keepDifferentNumberingDisabled: 'Mantenere numerazione fatture diversa per ogni sede dell\'ordine non è un\'opzione disponibile con il tuo piano.',
    locationEmailDesc: 'Questo ti permette di inviare email e fatture tradotte in base alla sede dell\'ordine: sede inventario, indirizzo di spedizione o di fatturazione',
    upgradePlan: 'Aggiorna il tuo piano',
    matchingCriteria: 'Criteri di corrispondenza',
    locationId: 'ID sede',
    shippingCountryCode: 'Codice paese indirizzo di spedizione',
    billingCountryCode: 'Codice paese indirizzo di fatturazione',
    matchLocationDesc: 'Abbina una sede in base all\'ID sede dell\'ordine, al codice paese di spedizione o di fatturazione.',
    companyInfo: 'Informazioni aziendali',
    name: 'Nome',
    website: 'Sito web',
    registrationNumber: 'Numero di registrazione',
    taxId: 'Partita IVA',
    addressSection: 'Indirizzo',
    streetName: 'Via',
    streetNumber: 'Numero civico',
    zip: 'CAP',
    city: 'Città',
    region: 'Regione',
    country: 'Paese',
    bankingInfo: 'Informazioni bancarie',
    bankName: 'Nome banca',
    swift: 'Swift',
    currency: 'Valuta',
    iban: 'IBAN',
    invoicing: 'Fatturazione',
    decimalPlaces: 'Cifre decimali',
    invoicesPrefix: 'Prefisso fatture',
    currentInvoiceNumber: 'Numero fattura attuale',
    creditNotesPrefix: 'Prefisso note di credito',
    currentCreditNoteNumber: 'Numero nota di credito attuale',
    lastInvoiceDate: 'Data ultima fattura',
    noInvoicesYet: 'Nessuna fattura creata ancora.',
    confirmReverting: 'Conferma ripristino sistema',
    allInvoicesAfter: 'Tutte le fatture e i relativi storni emessi dopo',
    willBeRemoved: 'verranno rimossi. Continuare con il ripristino del sistema?',
    cancel: 'Annulla',
    revert: 'Ripristina',
    revertDesc: 'Il ripristino del sistema cancellerà tutte le fatture create dopo la data selezionata.',
    revertToDate: 'Ripristina a questa data',
    reverting: 'Ripristino del sistema in corso, attendere...',
    useOrderNumbering: 'Usa numerazione ordini',
    showVat: 'Mostra IVA sulle fatture',
    overrideTaxes: 'Sovrascrivi imposte',
    pricesIncludeTax: 'I prezzi includono le imposte',
    productsTaxRate: 'Aliquota fiscale prodotti',
    shippingTaxRate: 'Aliquota fiscale spedizione',
    skusSeparated: 'SKU separati da punto e virgola',
    skusTaxRate: 'Aliquota fiscale SKU',
    useOrderDates: 'Usa le date di creazione ordine per le fatture',
    convertCurrency: 'Converti i prezzi nella valuta in cui il cliente paga',
    unsavedChanges: 'Modifiche non salvate',
    discard: 'Annulla',
    save: 'Salva',
  },
  drafts: {
    pageTitle: 'Bozze',
    pageDescription: 'Manage your draft orders',
    title: 'Bozze',
    download: 'Scarica',
    newDraft: 'Nuova bozza',
    exporting: 'Esportazione {status}%...',
    accessNotGranted: 'Accesso alle bozze ordine non concesso. Per favore',
    reLogin: 'accedi di nuovo',
    toGrantPermissions: 'per concedere i permessi necessari per le "Bozze ordine".',
    pushFailed: 'Invio a Shopify fallito:',
    exportError: 'Errore di esportazione:',
    confirmDelete: 'Sei sicuro di voler eliminare questa bozza?',
    incompleteCustomer: 'I dati del cliente sono incompleti:',
    pushWithoutCustomer: 'La bozza verrà inviata a Shopify senza i dati del cliente. Continuare?',
    customerNotInShopify: 'Questo cliente non esiste ancora in Shopify.',
    warnings: 'Avvisi:',
    createCustomerAndPush: 'Creare il cliente in Shopify e inviare la bozza d\'ordine?',
  },
  draftEdit: {
    number: "Numero",
    prefix: "Prefisso",

    newDraft: 'Nuova bozza',
    editDraft: 'Modifica bozza',
    viewInShopify: 'Visualizza in Shopify',
    back: 'Indietro',
    createDraft: 'Crea bozza',
    saveChanges: 'Salva modifiche',
    documentType: 'Tipo documento',
    draftOrder: 'Bozza ordine',
    quote: 'Preventivo',
    proforma: 'Proforma',
    manualInvoice: 'Fattura manuale',
    currency: 'Valuta',
    expiryDate: 'Data di scadenza',
    status: 'Stato',
    draft: 'Bozza',
    sent: 'Inviato',
    accepted: 'Accettato',
    customer: 'Cliente',
    firstName: 'Nome',
    lastName: 'Cognome',
    email: 'Email',
    phone: 'Telefono',
    company: 'Azienda',
    taxId: 'Partita IVA',
    billingAddress: 'Indirizzo di fatturazione',
    address: 'Indirizzo',
    aptSuite: 'Int./Scala',
    city: 'Città',
    province: 'Provincia',
    countryField: 'Paese',
    zip: 'CAP',
    shippingAddress: 'Indirizzo di spedizione',
    sameAsBilling: 'Uguale alla fatturazione',
    lineItems: 'Voci',
    shipping: 'Spedizione',
    shippingTitle: 'Titolo',
    shippingPlaceholder: 'es. Spedizione standard',
    price: 'Prezzo',
    note: 'Nota',
    notePlaceholder: 'Nota interna o messaggio per il cliente...',
    summary: 'Riepilogo',
    subtotal: 'Subtotale',
    discounts: 'Sconti',
    tax: 'Imposta',
    total: 'Totale',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Inserisci l\'indirizzo del tuo negozio',
    loginWith: 'Accedi con',
    createAccount: 'Crea un nuovo account',
    placeholder: 'nome-del-tuo-negozio',
    shopRequired: 'Il nome del negozio è obbligatorio',
    login: 'Accedi',
    shopify: 'Shopify',
    terms: 'Termini e condizioni',
    privacy: 'Informativa sulla privacy',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Ti piace Invoice Browse?',
    description: 'Hai creato le tue prime fatture! Se trovi l\'app utile, una rapida recensione sullo Shopify App Store ci aiuta molto.',
    reward: 'Come ringraziamento, azzereremo il tuo contatore di utilizzo mensile',
    leaveReview: 'Lascia una recensione',
    maybeLater: 'Forse più tardi',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Benvenuto su Invoice Browse',
    welcomeContent: 'Lascia che ti mostri come puoi usarlo.',
    dashboardTitle: 'Dashboard',
    dashboardContent: 'La schermata che stai vedendo è la dashboard principale. Qui puoi trovare tutti gli ordini e puoi esportarli in diversi tipi di documenti come: fatture, documenti di trasporto e altri.',
    automationTitle: 'Semplificati la vita',
    automationContent: 'Abilita l\'automazione per creare fatture ogni volta che gli ordini vengono pagati o rimborsati.',
    templatesTitle: 'Personalizza modelli',
    templatesContent: 'Entra qui per tradurre il tuo modello, personalizzarlo o crearne uno nuovo.',
    deliveryTitle: 'Consegna',
    deliveryContent: 'Configura la nostra app per copiare automaticamente i documenti creati su FTP, Google Drive, o come allegati per le email.',
    settingsTitle: 'Impostazioni',
    settingsContent1: 'Modifica il numero di telefono aziendale, l\'email e altri campi utilizzati nei documenti.',
    settingsContent2: 'Cambia il numero iniziale dei documenti o cancella i documenti creati dopo una data.',
    settingsContent3: 'Sovrascrivi le aliquote IVA per spedizione e prodotti',
    settingsContent4: 'Cambia le cifre decimali per i numeri',
    reviewTitle: 'Scrivi una recensione',
    reviewContent: 'Supporta il nostro team scrivendoci una buona recensione!',
    tourTitle: 'Tour di benvenuto',
    tourContent: 'Ehi, puoi riaprire questo tour da qui.',
    createDocTitle: 'Crea il tuo primo documento',
    createDocContent: 'Clicca sul pulsante Crea per creare il tuo primo documento.',
    docNumberTitle: 'Numero documento',
    docNumberContent: 'Il primo documento ha il numero 1 assegnato. Se vuoi iniziare con un altro numero puoi cambiarlo dalle Impostazioni.',
    downloadDocTitle: 'Scarica documento',
    downloadDocContent: 'Clicca sul menu a tendina Scarica e seleziona un modello di documento per esportare il tuo ordine come PDF.',
  },
  common: {
    save: 'Salva',
    cancel: 'Annulla',
    close: 'Chiudi',
    discard: 'Annulla',
    delete: 'Elimina',
    edit: 'Modifica',
    create: 'Crea',
    loading: 'Caricamento...',
    unsavedChanges: 'Modifiche non salvate',
    upgradePlan: 'Aggiorna il tuo piano',
  },
  languageSelector: {
    label: 'Lingua',
    auto: 'Rilevamento automatico',
  },
  draftList: {
    draftNum: 'Bozza #',
    shopifyId: 'Shopify ID',
    type: 'Tipo',
    customer: 'Cliente',
    total: 'Totale',
    status: 'Stato',
    delivered: 'Consegnato',
    date: 'Data',
    actions: 'Azioni',
    noCustomer: 'Nessun cliente',
    noDrafts: 'Nessuna bozza o preventivo trovato.',
    loading: 'Caricamento...',
    download: 'Scarica',
    default: 'Predefinito',
    pending: 'In attesa',
    deliverNow: 'Consegna ora',
    deliveryDetails: 'Dettagli consegna',
    sent: 'Inviato',
    failed: 'Fallito',
    deliverAgain: 'Consegna di nuovo',
    partial: 'Parziale',
    notDelivered: 'Non consegnato',
    deliveryFailed: 'Consegna fallita',
    unknown: 'Sconosciuto',
    edit: 'Modifica',
    send: 'Invia',
    pushToShopify: 'Invia a Shopify',
    complete: 'Completa',
    duplicate: 'Duplica',
    delete: 'Elimina',
    quote: 'Preventivo',
    proforma: 'Proforma',
    draftOrder: 'Ordine bozza',
    manualInvoice: 'Fattura manuale',
  },
  draftSearch: {
    createdBtw: 'Creato tra',
    draftNum: 'Bozza #',
    shopifyId: 'Shopify ID',
    customer: 'Cliente',
    status: 'Stato',
    type: 'Tipo',
    delivery: 'Consegna',
    any: 'Tutti',
    draft: 'Bozza',
    sent: 'Inviato',
    accepted: 'Accettato',
    expired: 'Scaduto',
    converted: 'Convertito',
    cancelled: 'Annullato',
    quote: 'Preventivo',
    proforma: 'Proforma',
    draftOrder: 'Ordine bozza',
    manualInvoice: 'Fattura manuale',
    delivered: 'Consegnato',
    notDelivered: 'Non consegnato',
    pending: 'In attesa',
    search: 'Cerca',
  },
  draftDownload: {
    title: 'Scarica bozze e preventivi...',
    selectTemplate: 'Seleziona un modello dalla galleria per esportare bozze, preventivi o proforma.',
    allDraftsBetween: 'Tutte le bozze tra',
    selectedDrafts: 'Bozze selezionate',
    and: 'e',
    status: 'Stato',
    documentType: 'Tipo documento',
    any: 'Tutti',
    draft: 'Bozza',
    sent: 'Inviato',
    accepted: 'Accettato',
    expired: 'Scaduto',
    converted: 'Convertito',
    cancelled: 'Annullato',
    quote: 'Preventivo',
    proforma: 'Proforma',
    draftOrder: 'Ordine bozza',
    manualInvoice: 'Fattura manuale',
    format: 'Formato',
    noTemplates: 'Nessun modello trovato',
    noTemplatesForType: 'Nessun modello trovato per il tipo documento "{type}".',
    installTemplates: 'Installa modelli',
    toStartExporting: 'per iniziare ad esportare.',
    noteChrome: 'Nota: Per un download ottimale si consiglia Chrome e la disattivazione di qualsiasi ad blocker.',
    cancel: 'Annulla',
    downloadIndividually: 'Scarica singolarmente',
    downloadGrouped: 'Scarica raggruppato',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Installa nuovo modello',
    tabStyle: 'Stile',
    tabContent: 'Contenuto',
    tabTranslations: 'Traduzioni',
    tabSettings: 'Impostazioni',
    tabCode: 'Codice',
    tabCopilot: 'Copilota IA',
    logo: 'Logo',
    colorPalette: 'Palette colori',
    colorText: 'Testo',
    colorBg: 'Sfondo',
    colorBorder: 'Bordo',
    colorPrimary: 'Primario',
    colorAccent: 'Accento',
    font: 'Font',
    fontDefault: 'Predefinito (DM Sans)',
    fontSize: 'Dimensione font',
    fontSizeDefault: 'Predefinita (11.5px)',
    fontSizeCompact: 'Compatto',
    fontSizeSmall: 'Piccolo',
    fontSizeMediumSmall: 'Medio-piccolo',
    fontSizeMedium: 'Medio',
    fontSizeMediumLarge: 'Medio-grande',
    fontSizeLarge: 'Grande',
    fontSizeExtraLarge: 'Extra grande',
    documentTitle: 'Titolo documento',
    documentTitlePlaceholder: 'es. Fattura, Fattura fiscale...',
    noToggleSupport: 'Questo modello non supporta i controlli a levetta. Passa a un modello della galleria per la personalizzazione completa.',
    sections: 'Sezioni',
    shippingAddress: 'Indirizzo di spedizione',
    bankPaymentDetails: 'Dati bancari/di pagamento',
    paymentStatusBadge: 'Badge stato pagamento',
    orderNotes: 'Note ordine',
    trackingFulfillment: 'Tracciamento/evasione',
    termsConditions: 'Termini e condizioni',
    signatureLines: 'Righe per firma',
    qrCode: 'Codice QR',
    lineItems: 'Articoli',
    taxColumns: 'Colonne imposte (IVA)',
    productSku: 'SKU prodotto',
    productImages: 'Immagini prodotto',
    discountBreakdown: 'Dettaglio sconti',
    itemWeight: 'Peso articolo',
    hsCode: 'Codice HS (dogana)',
    mergeDiscounts: 'Incorpora sconti nel prezzo del prodotto',
    showOrderDiscountAsSummary: 'Mostra lo sconto ordine come riga di riepilogo',
    totals: 'Totali',
    subtotalBeforeTax: 'Subtotale (prima delle imposte)',
    taxBreakdownByRate: 'Dettaglio imposte per aliquota',
    shippingCostSeparate: 'Costo spedizione come riga separata',
    dueDate: 'Data di scadenza',
    formatting: 'Formattazione',
    dateFormat: 'Formato data',
    decimalPlaces: 'Decimali',
    paymentTerms: 'Condizioni di pagamento',
    paymentTermsNone: 'Nessuna',
    thankYouMessage: 'Messaggio di ringraziamento',
    thankYouPlaceholder: 'Grazie per il vostro acquisto!',
    countryMatchTitle: 'Usa questo modello quando l\'indirizzo di spedizione o fatturazione corrisponde a questo paese',
    addressType: 'Tipo indirizzo',
    addressDisabled: 'Disabilitato',
    addressShipping: 'Indirizzo di spedizione',
    addressBilling: 'Indirizzo di fatturazione',
    country: 'Paese',
    anyCountry: 'Qualsiasi paese',
    countryMatchDesc: 'Quando abilitato, questo modello verrà usato automaticamente per gli ordini il cui indirizzo selezionato corrisponde al paese scelto.',
    languagePreset: 'Lingua preimpostata',
    selectLanguage: 'Seleziona lingua...',
    languagePresetDesc: 'Selezionando una lingua vengono compilate tutte le etichette sottostanti. Puoi poi personalizzare i singoli campi.',
    paperSize: 'Dimensione carta',
    format: 'Formato',
    orientation: 'Orientamento',
    portrait: 'Verticale',
    landscape: 'Orizzontale',
    margin: 'Margine (cm)',
    template: 'Modello',
    templateName: 'Nome',
    systemAlias: 'Alias sistema',
    systemAliasDesc: 'per rotte URL POS/Admin',
    systemAliasNone: 'Nessuno',
    defaultTemplate: 'Modello predefinito',
    defaultTemplateDesc: 'Usato per link diretti condivisi con i clienti.',
    posRouteDesc: 'Mappa a /template/[alias]/receipt.pdf per integrazione POS.',
    documentType: 'Tipo documento',
    invoiceCreditNote: 'Fattura + Nota di credito',
    order: 'Ordine',
    invoiceOnly: 'Solo fattura',
    quoteEstimate: 'Preventivo/Stima',
    proformaInvoice: 'Fattura proforma',
    refund: 'Rimborso',
    stornoInvoice: 'Fattura di storno',
    creditNoteOnly: 'Solo nota di credito',
    reportLiquid: 'Report (solo Liquid)',
    hideRemovedItems: 'Nascondi articoli rimossi/rimborsati',
    location: 'Posizione',
    locationEmpty: 'Lascia vuoto per usare per tutte le posizioni',
    dangerZone: 'Zona pericolosa',
    dangerZoneDesc: 'Rimuovi permanentemente questo modello dal tuo account.',
    removeTemplate: 'Rimuovi modello',
    bodyTemplate: 'Modello principale',
    bodyTemplateDesc: 'Usa sintassi Mustache o Liquid. Clicca su uno snippet:',
    rowTemplate: 'Modello riga',
    rowTemplateDesc: 'Renderizzato una volta per articolo. Clicca su uno snippet:',
    variableReference: 'Riferimento variabili',
    formatCode: 'Formatta codice',
    insert: 'Inserisci',
    copy: 'Copia',
    loadModelContinue: 'Carica modello e continua',
    cancel: 'Annulla',
    copilotPlaceholder: 'Prova: traduci in italiano, mostra colonne imposte, aggiungi codice a barre...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Annulla',
    redo: 'Ripeti',
    aiThinking: 'L\'IA sta pensando...',
    proposedChanges: 'Modifiche proposte',
    applyChanges: 'Applica modifiche',
    dismiss: 'Ignora',
    aiEngineReady: 'Motore IA pronto',
    loadingAiModel: 'Caricamento modello IA...',
    aiEngineOff: 'Motore IA spento —',
    loadForAdvanced: 'carica per modifica avanzata',
    instantCommands: 'traduci, mostra/nascondi sezioni, aggiungi snippet, cambia font/colori/carta',
    aiEngineDesc: 'modifiche HTML strutturali, cambiamenti di layout, modifiche personalizzate',
    aiLocalDesc: 'Il modello viene eseguito localmente via WebGPU — nessun dato lascia il browser.',
    aiUpgradeDesc: 'passa a Starter o Professional per sbloccare la modifica IA avanzata.',
    upgrade: 'Aggiorna',
    loadAiQuestion: 'Caricare motore IA?',
    loadAiDesc: 'Il modello IA verrà scaricato ed eseguito localmente via WebGPU. Richiede ~1-3 GB di VRAM/RAM libera e una GPU moderna.',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/it.js